<section aria-labelledby="section-title">
  <div class="row">
    <div class="col-sm-10 col-md-8 mx-auto">
      <h1 id="section-title">{{ 'DIPRSRegistration.phoneNumber.title' | translate }}</h1>

      <ng-container>
        <p class="text-center">
          <span>{{ 'DIPRSRegistration.phoneNumber.securityCode' | translate }}</span>
          <button type="button"
                  #button
                  (click)="showModal(button)"
                  aria-label="phone number"
                  [title]="'DIPRSRegistration.phoneNumber.help.modal.altText' | translate"
                  [attr.modal-title]="'DIPRSRegistration.phoneNumber.help.modal.title' | translate"
                  class="td-btn-unstyled td-icon-wrapper ml-10">
            <span class="td-icon icon-small td-icon-question" aria-hidden="true"></span>
          </button>
        </p>

        <form [formGroup]="phoneNumberForm" novalidate autocomplete="off">
          <div class="row">
            <div class="col-sm-6 offset-sm-3 mb-0 form-group">
              <input
                formControlName="phoneNumber"
                id="phoneNumber"
                [placeholder]="'DIPRSRegistration.phoneNumber.placeholder' | authTranslate"
                class="form-control"
                [attr.aria-label]="'DIPRSRegistration.phoneNumber.title' | translate"
                aria-describedby="phoneNumberErrorMessage"
                [imask]="phoneNumberMaskOptions"
                [unmask]="true"
                [class.is-invalid]="phoneNumberForm.get('phoneNumber').touched && phoneNumberForm.get('phoneNumber').invalid"
                [attr.aria-invalid]="phoneNumberForm.get('phoneNumber').touched && phoneNumberForm.get('phoneNumber').invalid"
              />
              <div id="phoneNumberErrorMessage" role="alert" class="td-error"
                   *ngIf="phoneNumberForm.get('phoneNumber').touched && phoneNumberForm.get('phoneNumber').invalid">
                <div role="alert" aria-live="assertive" aria-atomic="true" *ngIf="phoneNumberForm.get('phoneNumber').errors">
                  <span class="td-error-symbol" [title]="'DIPRSRegistration.phoneNumber.error.altText' | translate"></span>
                  <span class="sr-only">{{ 'DIPRSRegistration.error.label' | translate }}</span>
                  {{ 'DIPRSRegistration.phoneNumber.error.valid' | translate }}
                </div>
              </div>
            </div>
          </div>
          <div class="td-toolbar row flex-sm-row-reverse">
            <div class="col-sm-6">
              <button type="submit" class="btn btn-block td-btn-primary-light" [disabled]="isSubmitClicked"
                      [dipseWebMetricEvent]="'myins:seamless:enrollment:confirm:phone:continue'" (click)="submit()">
              {{'DIPRSRegistration.phoneNumber.button.continue' | translate}}
              </button>
            </div>
            <div class="col-sm-6">
              <button type="button" class="btn btn-block td-btn-secondary-clear"
                      [dipseWebMetricEvent]="'myins:seamless:enrollment:confirm:phone:cancel'" #cancelbutton (click)="cancel(cancelbutton)">
                {{'DIPRSRegistration.phoneNumber.button.cancel' | translate}}
              </button>
            </div>
          </div>
        </form>

        <p class="text-center">
          <a href="javascript:void(0);" class="td-cta" (click)="!isSubmitClicked ? selectNoAccess() : false" 
             tabindex="0" [class.disabled]="isSubmitClicked" 
             [dipseWebMetricEvent]="'myins:seamless:enrollment:no:access:to:these:numbers'">
            <strong>{{ "DIPRSRegistration.phoneNumber.link.no.access" | translate }}</strong>
            <span class="td-icon td-icon-rightCaret" aria-hidden="true"></span>
          </a>
        </p>
      </ng-container>
    </div>
  </div>
</section>
